<template>
    <div style="height: 100%">
      <!--表格开始-->
      <div class="table">
        <template>
          <el-table
            ref="tempTable"
            auto-width
            border
            height="100%"
            @selection-change="SelectEvent"
            @select="selectId"
            @select-all="selectAll"
            @row-click="rowClick"
            :data="tableData"
            :row-click="getRowKeys"
            :cell-style="cellStyle"
            :highlight-current-row="highlight"
            :cell-class-name="cellClassName"
            :tree-props="{children: 'children'}"
            @cell-click="cellClick"
            :row-key="getRows"
            :expand-row-keys="expand_row_keys"
            @expand-change="expand_change"
            style="width: 100%"
          >
            <!--固定两列 多选 序号-->
            <el-table-column v-if="serialNumber" :width="(60/10*htmlFontSize)+'px'" type="selection">
            </el-table-column>
            <el-table-column
              label="序号"
              :width="(60/10*htmlFontSize)+'px'"
              v-if="sequenceNumber == undefined ? true : sequenceNumber"
            >
              <template slot-scope="scope">{{
                scope.$index + 1 + (currentPage - 1) * pageSize
              }}</template>
            </el-table-column>
            <!--固定两列结束-->
            <!--循环出其他列-->
            <el-table-column
              style="background-color: #73b3fc; color: #fff"
              v-for="(item, key) in tableKey"
              :sortable="!!item.sortable"
              :key="key"
              :prop="item.value"
              show-overflow-tooltip
              :width="item.width/10*htmlFontSize"
              :label="item.name"
  
            >
              <template slot-scope="scope">
                <!-- 判断是否存在 render 方法，存在则调用，否则使用默认渲染 -->
                <!-- <div v-if="item.render" v-html="item.render(scope)"></div> -->
                <div v-if="item.slot">
                  <slot :name="item.slot" :data="scope"></slot>
                </div>
                <div v-else v-html="scope.row[item.value]"></div>
              </template>
            </el-table-column>
            <template v-if="btn_switch != null">
              <!-- 开关按钮 -->
              <el-table-column
                v-for="btn in btn_switch"
                :key="btn.id"
                :width="120/10*htmlFontSize"
                :label="btn.label"
                show-overflow-tooltip
              >
              <template slot="header" v-if="btn.tooltip">
                <div style="display: flex;align-items: center;">
                  <div>{{ btn.label }}</div>
                  <el-tooltip class="item" effect="dark" :content="btn.tooltip" placement="top-start">
                    <i class="el-icon-question" style="margin-left: 0.5rem;font-size: 14px;"></i>
                  </el-tooltip>
                </div>
              </template>
                <template slot-scope="scope">
                  <el-switch
                    class="switchStyle"
                    :key="btn.id"
                    v-model=scope.row[btn.switchProperty]
                    :active-value="1"
                    :inactive-value="0"
                    :disabled="btn.disabled"
                    @change="
                      practiceSwitch(
                        btn.method,
                        scope.row,
                        scope.$index,
                        scope.row.status
                      )
                    "
                  >
                  </el-switch>
                </template>
              </el-table-column>
            </template>
  
            <!--判断是否有下级展开功能 如果有就显示展开并把二级数据填充-->
            <el-table-column
              ref="expandRef"
              v-if="is_expand"
              type="expand"
              width="0"
            >
              <template>
                <el-table
                  ref="refChildrenTable"
                  @row-click="rowClick"
                  @select="selectTwoId"
                  @selection-change="SelectEventTwo"
                  :data="tableChildren"
                  :cell-style="cellChildrenStyle"
                  @cell-click="cellChildrenClick"
                  style="width: 100%; height: 30%"
                >
                  <!--固定两列 多选 序号-->
                  <el-table-column type="selection"> </el-table-column>
                  <el-table-column label="序号" :width="60/10*htmlFontSize+'px'">
                    <template slot-scope="scope">
                      {{ scope.$index + 1 }}
                    </template>
                  </el-table-column>
                  <!--固定两列结束循环出其他列-->
                  <el-table-column
                    v-for="(item, key) in tableKeyList"
                    :sortable="item.sortable ? true : false"
                    :show-overflow-tooltip="item.tooltip ? true : false"
                    :key="key"
                    :prop="item.value"
                    :label="item.name"
                    style="background-color: #d32e31"
                  >
                  </el-table-column>
  
                  <!--操作按钮-->
                  <el-table-column
                    v-if="btnChildren != null"
                    label="操作"
                    :width="300/10*htmlFontSize"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <el-button
                        class="addBtn"
                        :type="btn.type"
                        v-for="(btn, index) in btnChildren"
                        :key="index"
                        @click="select(btn.method, scope.row, scope.$index)"
                      >
                        <el-tooltip
                          effect="light"
                          placement="bottom"
                          :content="btn.content"
                          v-if="btn.class"
                        >
                          <i :class="btn.class" size="small"></i>
                        </el-tooltip>
                        <div>{{ btn.name }}</div>
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column
              v-if="btn_group != null"
              :width="operationWidth ? (operationWidth/10*htmlFontSize) : (300/10*htmlFontSize)"
              label="操作"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <div
                  v-for="btn in btn_group"
                  :key="btn.name"
                  style="float: left; margin-right: 1rem"
                >
                  <el-button
                    :type="btn.type"
                    @click="select(btn.method, scope.row, scope.$index)"
                    v-if = btn.isShowBtn>
                    <div v-if="isShowBtn ">
                      <i
                        :class="btn.class"
                        size="mini"
                        @row-click="select(btn.method, scope.row, scope.$index)"
                      >
                      </i>
                    </div>
                    <div v-else>
                      {{ btn.name }}
                    </div>
                  </el-button>
                  <!--                </el-tooltip>-->
                </div>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
      <!--表格结束-->
      <!--分页开始-->
      <div class="block" v-if="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          background
          :pager-count="5"
          :hide-on-single-page="tableData.length == 0 ? true : false"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          :layout="$store.state.media.layout"
          :total="totalSize"
        >
        </el-pagination>
      </div>
      <!--分页结束-->
    </div>
  </template>
  <script>
  export default {
    name: "Table",
    data() {
      return {
        allSelectObj:{},
      };
    },
    props: [
      "sequenceNumber",
      "serialNumber",
      "pagination",
      "columnColor",
      "cellClass",
      "columnClick",
      "columnChildrenColor",
      "tableData",
      "tableKey",
      "expand_row_keys",
      "btnChildren",
      "totalSize",
      "btn_group",
      "row_width",
      "navHeight",
      "is_expand",
      "tableChildren",
      "tableKeyList",
      //是否显示按钮
      "isShowBtn",
      "btn_switch",
      "border",
      "operationWidth",
      "currentPage",
      "pageSize",
      //是否跨页选择
      "crossPage",
      "highlight"
    ],
    created() {},
    mounted() {},
    methods: {
      /**设置默认高亮行 */
      setDefaultHighLight(data){
        this.$refs.tempTable.setCurrentRow(data);
      },
      /**初始化选中数据 */
      initSelection(allSelectObj){
        this.allSelectObj=allSelectObj||{};
      },
      //测试数据使用
      // add(){
      //     console.log(this.tableData)
      //     // console.log(this.tableKey)
      // },
  
      handleSizeChange(val) {
        // this.pageSize = val;
        this.$emit("changePageSize", val);
        //this.$parent.changePageSize();
      },
      // 翻页
      handleCurrentChange(val) {
        // this.currentPage = val;
        this.$emit("changeCurrentPage", val);
        //this.$parent.changeCurrentPage(val);
      },
      // click(callback, n) {
      //         callback(n);
      //     },
      del(index) {
        this.tableData.splice(index, 1);
      },
      select(method, val, index) {
        let info = {
          obj: val,
          index: index,
        };
        this.$emit(method, JSON.parse(JSON.stringify(info)));
      },
      practiceSwitch(method, val, index, type) {
        let info = {
          obj: val,
          index: index,
          type: type,
        };
        this.$emit(method, info);
      },
      rowClick(row, column) {
        if (column) {
          if (column.label === "操作") {
            //如果点击的是操作那一列，则不做任何处理;
            return false;
          }
          this.$emit("rowClick", row);
        }
      },
      expand_change(row, expandedRows) {
        //展开行时用到的方法
        this.is_expand&&this.$emit(this.is_expand, row, expandedRows);
      },
      selectId(selection, row) {
        /**判断是勾选还是取消勾选 */
        var el=selection.find(item=>item.id==row.id);
        var flag=true;
        if(el){
          flag=true;
        }else{
          flag=false
        }
        if(this.crossPage){
          if(!flag){
            delete this.allSelectObj[row.id];
          }else{
            this.allSelectObj[row.id]=row;
          }
          this.$emit('selectId',Object.values(this.allSelectObj),row);
          return;
        }
        this.$emit("selectId", selection, row);
      },
      selectAll(a){
        if(this.crossPage){
         if(a.length==0){
          this.tableData.forEach(item=>{
            delete this.allSelectObj[item.id];
          })
         }else{
          a.forEach(row=>{
            this.allSelectObj[row.id]=row;
          })
         }
         this.$emit("selectAll",Object.values(this.allSelectObj));
         return;
        }
        this.$emit("selectAll", a);
      },
      selectTwoId(selection, row) {
        this.$emit("selectTwoId", selection, row);
      },
      getRowKeys(row) {
        return row.id;
      },
      getRows(row) {
        //每次只展示一行使用的方法
        return row.id;
      },
      cellClassName({ row, columnIndex }) {
        if (this.cellClass && this.cellClass.includes(columnIndex)) {
          return row.className;
        }
      },
      cellStyle({ columnIndex }) {
        //根据列来区分是否可以点击并修改字体色
        if (this.columnColor && this.columnColor.includes(columnIndex)) {
          return "color:#241FFF;cursor:pointer";
        }
      },
      cellChildrenStyle({ columnIndex }) {
        if (
          this.columnChildrenColor &&
          this.columnChildrenColor.includes(columnIndex)
        ) {
          return "color:#241FFF;cursor:pointer";
        }
      },
      cellClick(row, column) {
        if (this.columnClick) {
          this.columnClick.forEach((item) => {
            if (this.serialNumber == false) {
              if (this.tableKey[item - 1].name === column.label) {
                this.$emit("cellClick", row, column);
              }
            } else {
              if (this.tableKey[item - 2].name === column.label) {
                this.$emit("cellClick", row, column);
              }
            }
          });
        }
      },
      cellChildrenClick(row, column) {
        if (this.columnChildrenColor) {
          this.columnChildrenColor.forEach((item) => {
            if (this.tableKeyList[item - 2].name === column.label) {
              this.$emit("cellChildrenClick", row);
            }
          });
        }
      },
      rowChecked() {
        this.$nextTick(()=>{
          this.tableData.forEach(row=>{
          if(this.allSelectObj[row.id]){
            this.$refs.tempTable.toggleRowSelection(row, true);
          }
        })
        })
      },
      // 批量删除用户选择的id
      SelectEvent(row) {
        this.$emit("SelectEvent", row);
      },
      // 二级选择联动
      SelectEventTwo(row) {
        this.$emit("SelectEventTwo", row);
      },
      hasChildren(row) {
        return row.children && row.children.length > 0;
      },
    },
    computed: {
      htmlFontSize(){
        return this.$store.state.common.htmlFontSize;
      }
    }
  };
  </script>
  
  <style lang="less" scoped>
.block {
  padding: 2rem 0;
  text-align: center;
}
.el-table__header-wrapper {
  height: 9rem;
}
/deep/.el-table__body-wrapper {
  height: calc(100% - 4rem) !important;
  overflow-y: auto;
}
.table {
  height: calc(100% - 5rem);
}
/deep/.el-table th.gutter {
  display: none !important;
}
/deep/.el-table__header {
  table-layout: auto;
}

/deep/.el-table__expand-column {
  padding: 0;
  .cell {
    padding: 0px;
    .el-table__expand-icon--expanded {
      transform: none;
      i {
        transform: rotate(90deg);
      }
    }
    .el-table__expand-icon {
      height: 4.7rem;
    }
  }
}


// 表格中按钮样式和图标
[class^="al-"],
[class*=" al-"] {
  font-size: 14px;
}
.el-button--small {
  padding: 0.7rem 1.3rem;
}
.el-button--small {
  font-size: 14px;
}
/deep/.table{
    height:calc(100% - 5rem);
    img{
      width: 4rem !important;
      height: 4rem !important;
    }
}
/deep/.el-table__expanded-cell {
  padding: 0px;
  .is-leaf {
    background-color: #f6fbff;
    color: #7994af;
  }
  .el-table__row {
    background-color: #fff;
  }
}
/deep/.el-table--border td {
  border-right: none;
  height: 5rem;
  font-size: 14px;
  color: #333333;
}
/deep/.el-table--border th {
  border-right: none;
  background-color: #f5f6f9;
  height: 5rem;
  font-size: 14px;
  color: #555555;
}
/deep/.el-table__expanded-cell {
  padding: 1rem;
  background-color: #ebf5fe;
  height: unset !important;
}
/deep/.el-button {
  border: none;
  color: #356cfa;
}
/deep/.el-table{
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
/deep/.el-table__header-wrapper{
  background-color: #E0E8F2;
  height: 4.8rem !important;
}
/deep/th{
  height: 4.8rem !important;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: var(--blue);
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: var(--blue) !important;
}
/deep/.cell{
  white-space: nowrap;
}
  </style>
  